import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updateUser, createUser } from "../../slices/users";
import { useNavigate } from 'react-router-dom';
import Select from '../select'

const translations = [
    gettext('Support'),
    gettext('Admin'),
    gettext('Username'),
    gettext('Username is required'),
    gettext('First name'),
    gettext('First name is required'),
    gettext('Last name'),
    gettext('Last name is required'),
    gettext('Email'),
    gettext('Invalid email address'),
    gettext('Role'),
    gettext("Select a role"),
    gettext('Password'),
    gettext('only fill out if you want to change password'),
    gettext('Confirm password'),
    gettext('Passwords must match'),
    gettext("Save"),
]

const UserForm = ({ user }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [selectedRole, setSelectedRole] = useState(user?.role)
    const authUser = useSelector((state) => state.auth.user)

    const onSubmit = (data) => {
        if (user) {
            Promise.resolve(dispatch(updateUser({ id: user.id, args: data })))
            .then(data => {
                console.log(data)
                navigate('/settings/users/')
            })
        } else {
            Promise.resolve(dispatch(createUser(data)))
            .then(data => {
                navigate('/settings/users/')
            })
        }
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        defaultValues: {
            username: user?.username,
            first_name: user?.first_name,
            last_name: user?.last_name,
            email: user?.email,
            password: "",
            password2: "",
        },
        mode: "onChange"
    });
    
    const roleOptions = [
        { value: 'support',  label: gettext('Support') },
        { value: 'admin', label: gettext('Admin') }
    ];
    
    const selectRole = (role) => {
        setSelectedRole(role.value)
        setValue('role', role.value)
    }

    const canEditRole = () => {
        if(user?.role == 'account_owner'){
            return false
        }
        if(['admin', 'account_owner'].includes(authUser?.role)){
            return true
        }
        return false
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <label>{gettext('Username')}</label>
                            <input type="text" {...register("username", {
                                required: gettext('Username is required'),
                            })} className={`form-control ${errors.username ? 'is-invalid' : ''}`} />
                            {errors.username && <p className="invalid-feedback">{errors.username.message}</p>}
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('First name')}</label>
                            <input type="text" {...register("first_name", {
                                required: gettext('First name is required'),
                            })} className={`form-control ${errors.first_name ? 'is-invalid' : ''}`} />
                            {errors.first_name && <p className="invalid-feedback">{errors.first_name.message}</p>}
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Last name')}</label>
                            <input type="text" {...register("last_name", {
                                required: gettext('Last name is required'),
                            })} className={`form-control ${errors.last_name ? 'is-invalid' : ''}`} />
                            {errors.last_name && <p className="invalid-feedback">{errors.last_name.message}</p>}
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Email')}</label>
                            <input type="email" {...register("email", {
                                required: 'Email is required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: gettext('Invalid email address')
                                }
                            })} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                            {errors.email && <p className="invalid-feedback">{errors.email.message}</p>}
                        </div>
                        { canEditRole() && 
                        <div className="col-12 mb-4">
                            <label>{gettext('Role')}</label>
                            <Select
                                value={roleOptions.filter((item) => item.value == selectedRole)}
                                placeholder={gettext("Select a role")}
                                options={roleOptions}
                                onChange={selectRole}
                            />
                        </div>
                        }
                        <div className="col-6 mb-4">
                            <label>{gettext('Password')} {user && gettext('only fill out if you want to change password')}</label>
                            <input type="password" {...register("password")} className="form-control" />
                        </div>
                        <div className="col-6 mb-4">
                            <label>{gettext('Confirm password')} {user && gettext('only fill out if you want to change password')}</label>
                            <input type="password" {...register("password2", {
                                validate: (value) => value === watch('password')
                            })} className={`form-control ${errors.password2 ? 'is-invalid' : ''}`} />
                            {errors.password2 && <span className="text-danger">{gettext('Passwords must match')}</span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form>
    )
}

export default UserForm